export default __webpack_public_path__ + "a4a04d4255aa4a9ad2ff0dd7b31060b6.png";